/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Facetedfilter_Selected1Inputs */

const id_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dipilih`)
};

const ms_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dipilih`)
};

const da_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`valgt`)
};

const de_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ausgewählt`)
};

const en_us2_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selected`)
};

const es_es2_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seleccionados`)
};

const es_mx2_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seleccionados`)
};

const fil_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`napili`)
};

const fr_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sélectionné(s)`)
};

const it_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selezionati`)
};

const hu_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kiválasztva`)
};

const nl_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geselecteerd`)
};

const no_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`valgt`)
};

const pl_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wybrane`)
};

const pt_br2_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selected`)
};

const pt_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selecionados`)
};

const ro_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selectat`)
};

const fi_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`valittu`)
};

const sv_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`valda`)
};

const vi_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đã chọn`)
};

const tr_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seçildi`)
};

const cs_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vybráno`)
};

const bg_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`избрани`)
};

const ru_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`выбрано`)
};

const uk_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`вибрано`)
};

const ar_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محدد`)
};

const hi_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित`)
};

const th_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่เลือก`)
};

const ja_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択中`)
};

const zh_cn2_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selected`)
};

const zh_hant1_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selected`)
};

const ko_table_facetedfilter_selected1 = /** @type {(inputs: Table_Facetedfilter_Selected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selected`)
};

/**
* | output |
* | --- |
* | "selected" |
*
* @param {Table_Facetedfilter_Selected1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_facetedfilter_selected1 = /** @type {((inputs?: Table_Facetedfilter_Selected1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Facetedfilter_Selected1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_facetedfilter_selected1(inputs)
	if (locale === "ms") return ms_table_facetedfilter_selected1(inputs)
	if (locale === "da") return da_table_facetedfilter_selected1(inputs)
	if (locale === "de") return de_table_facetedfilter_selected1(inputs)
	if (locale === "en-US") return en_us2_table_facetedfilter_selected1(inputs)
	if (locale === "es-ES") return es_es2_table_facetedfilter_selected1(inputs)
	if (locale === "es-MX") return es_mx2_table_facetedfilter_selected1(inputs)
	if (locale === "fil") return fil_table_facetedfilter_selected1(inputs)
	if (locale === "fr") return fr_table_facetedfilter_selected1(inputs)
	if (locale === "it") return it_table_facetedfilter_selected1(inputs)
	if (locale === "hu") return hu_table_facetedfilter_selected1(inputs)
	if (locale === "nl") return nl_table_facetedfilter_selected1(inputs)
	if (locale === "no") return no_table_facetedfilter_selected1(inputs)
	if (locale === "pl") return pl_table_facetedfilter_selected1(inputs)
	if (locale === "pt-BR") return pt_br2_table_facetedfilter_selected1(inputs)
	if (locale === "pt") return pt_table_facetedfilter_selected1(inputs)
	if (locale === "ro") return ro_table_facetedfilter_selected1(inputs)
	if (locale === "fi") return fi_table_facetedfilter_selected1(inputs)
	if (locale === "sv") return sv_table_facetedfilter_selected1(inputs)
	if (locale === "vi") return vi_table_facetedfilter_selected1(inputs)
	if (locale === "tr") return tr_table_facetedfilter_selected1(inputs)
	if (locale === "cs") return cs_table_facetedfilter_selected1(inputs)
	if (locale === "bg") return bg_table_facetedfilter_selected1(inputs)
	if (locale === "ru") return ru_table_facetedfilter_selected1(inputs)
	if (locale === "uk") return uk_table_facetedfilter_selected1(inputs)
	if (locale === "ar") return ar_table_facetedfilter_selected1(inputs)
	if (locale === "hi") return hi_table_facetedfilter_selected1(inputs)
	if (locale === "th") return th_table_facetedfilter_selected1(inputs)
	if (locale === "ja") return ja_table_facetedfilter_selected1(inputs)
	if (locale === "zh-CN") return zh_cn2_table_facetedfilter_selected1(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_facetedfilter_selected1(inputs)
	return ko_table_facetedfilter_selected1(inputs)
});
export { table_facetedfilter_selected1 as "table.facetedFilter.selected" }